export default __webpack_public_path__ + "static/media/WBLogo.7daaaedd.png";